import React from 'react';
interface AuditType {
  results: any[];
  name: string;
  handleHitSelect?: any;
}

const ResultsRow: React.FC<AuditType> = ({
  results,
  handleHitSelect,
  name,
}) => {
  return (
    <>
      <div className='view-history-body-frame-row'>
        <div
          className='view-history-body-frame-row-name'
          onClick={() => handleHitSelect(results, name)}
        >
          <div className='view-history-body-frame-row-date-text-names'>
            {name}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-text'>
            {results?.length}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>0</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultsRow;
